// extracted by mini-css-extract-plugin
export default {"content":"style_content__xHHMp","itemName":"style_itemName__8zodd"};